"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const mobx_utils_1 = require("mobx-utils");
const lodash_1 = require("lodash");
const util_1 = require("./util");
const base_store_1 = require("./base-store");
class EntityStore extends base_store_1.default {
    constructor() {
        super(...arguments);
        this.all = new Map();
        /**
         * For accessing MyEntityStore['EntityType'] to get E
         */
        this.EntityType = null;
        this.sortedBy = mobx_utils_1.computedFn(function sortedBy(property) {
            return lodash_1.sortBy(this.values, (v) => v.get(property));
        });
    }
    get(id) {
        if (id === undefined || id === null)
            throw new Error('Cannot call get with undefined | null');
        return this.all.get(util_1.toNum(id));
    }
    getAnd(id, callback, fallback) {
        if (id === undefined)
            return;
        const entity = this.get(id);
        if (entity) {
            return callback(entity);
        }
        if (fallback) {
            return fallback();
        }
    }
    forceGet(id) {
        const found = this.get(id);
        if (!found) {
            throw new Error(`Could not find ${JSON.stringify(id)}`);
        }
        return found;
    }
    forceGetCurrent() {
        if (!this.currentID) {
            throw new Error(`Could not find current (${this.currentID})`);
        }
        return this.forceGet(this.currentID);
    }
    take(id) {
        const entity = this.get(id);
        this.remove(id);
        return entity;
    }
    has(id) {
        if (id === undefined || id === null)
            throw new Error('Cannot call has with undefined | null');
        return this.all.has(util_1.toNum(id));
    }
    get size() {
        return this.all.size;
    }
    get length() {
        return this.size;
    }
    get isEmpty() {
        return this.size === 0;
    }
    remove(i) {
        const id = util_1.toNum(i);
        if (this.currentID === id)
            this.clearCurrent();
        return this.all.delete(id);
    }
    removeWhere(predicate) {
        for (const value of this) {
            if (predicate(value)) {
                this.remove(value);
            }
        }
    }
    removeWhereProps(predicate) {
        this.removeWhere((v) => predicate(v.props));
    }
    get keys() {
        return Array.from(this.all.keys());
    }
    get values() {
        return Array.from(this.all.values());
    }
    get valuesWithProps() {
        return this.values.map((v) => v.props);
    }
    get valuesWithPropsWithoutID() {
        return this.values.map((v) => v.propsWithoutID);
    }
    iter() {
        return this.all.values();
    }
    // tslint:disable-next-line
    [Symbol.iterator]() {
        return this.iter();
    }
    sort(compare) {
        const values = [...this];
        this.clear();
        this.addAll(values.sort(compare));
    }
    get entries() {
        return this.all.entries();
    }
    get current() {
        if (this.currentID === undefined)
            return undefined;
        return this.get(this.currentID);
    }
    setCurrent(e) {
        if (e === undefined) {
            this.currentID = undefined;
        }
        else {
            this.currentID = util_1.toNum(e);
        }
    }
    clearCurrent() {
        this.setCurrent(undefined);
    }
    clear() {
        this.all.clear();
        this.clearCurrent();
    }
    add(entity) {
        this.all.set(entity.id, entity);
        return entity;
    }
    addAsCurrent(entity) {
        this.add(entity);
        this.setCurrent(entity);
        return entity;
    }
    addAll(entities) {
        for (const entity of entities) {
            this.add(entity);
        }
        return entities;
    }
    /** @deprecated use valuesWithProps */
    get valuesWithIDs() {
        return this.valuesWithProps;
    }
    /** @deprecated use valuesWithPropsWithoutID */
    get valuesWithoutIDs() {
        return this.valuesWithPropsWithoutID;
    }
}
__decorate([
    mobx_1.observable,
    __metadata("design:type", Map)
], EntityStore.prototype, "all", void 0);
__decorate([
    mobx_1.observable,
    __metadata("design:type", Number)
], EntityStore.prototype, "currentID", void 0);
__decorate([
    mobx_1.action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], EntityStore.prototype, "take", null);
__decorate([
    mobx_1.computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], EntityStore.prototype, "size", null);
__decorate([
    mobx_1.computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], EntityStore.prototype, "length", null);
__decorate([
    mobx_1.computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], EntityStore.prototype, "isEmpty", null);
__decorate([
    mobx_1.action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], EntityStore.prototype, "remove", null);
__decorate([
    mobx_1.action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function]),
    __metadata("design:returntype", void 0)
], EntityStore.prototype, "removeWhere", null);
__decorate([
    mobx_1.action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function]),
    __metadata("design:returntype", void 0)
], EntityStore.prototype, "removeWhereProps", null);
__decorate([
    mobx_1.computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], EntityStore.prototype, "keys", null);
__decorate([
    mobx_1.computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], EntityStore.prototype, "values", null);
__decorate([
    mobx_1.computed,
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [])
], EntityStore.prototype, "valuesWithProps", null);
__decorate([
    mobx_1.computed,
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [])
], EntityStore.prototype, "valuesWithPropsWithoutID", null);
__decorate([
    mobx_1.action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function]),
    __metadata("design:returntype", void 0)
], EntityStore.prototype, "sort", null);
__decorate([
    mobx_1.computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], EntityStore.prototype, "entries", null);
__decorate([
    mobx_1.computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], EntityStore.prototype, "current", null);
__decorate([
    mobx_1.action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], EntityStore.prototype, "setCurrent", null);
__decorate([
    mobx_1.action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], EntityStore.prototype, "clearCurrent", null);
__decorate([
    mobx_1.action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], EntityStore.prototype, "clear", null);
__decorate([
    mobx_1.action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], EntityStore.prototype, "add", null);
__decorate([
    mobx_1.action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], EntityStore.prototype, "addAsCurrent", null);
__decorate([
    mobx_1.action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], EntityStore.prototype, "addAll", null);
exports.EntityStore = EntityStore;
exports.default = EntityStore;
//# sourceMappingURL=entity-store.js.map